<template>
  <div class="root_phone flex-col scaler_phone">
    <div class="block_1 flex-row">
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row" style="cursor: pointer;">
          <router-link to="/store/dashboard/profile">
            <img class="label_1" style="height:29px;" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" />
          </router-link>
        </div>
        <div class="section_1 flex-row justify-center" style="height:60px;">
          <span style="font-size: x-large;font-weight: 700;">修改密码</span>
        </div>
        <div class="section_2 flex-row">
          <el-form>
            <!-- label-position需与label-width一起使用才生效 -->
            <!--             <el-form-item prop="phone" label="手机号" label-position="left" label-width="80px">
              <el-input v-model="phone" placeholder="请输入手机号">
                <template #append>
                  <div class="append_button" @click="sendSmsCode">&nbsp;&nbsp;发送验证码&nbsp;&nbsp;</div>
                </template>
</el-input>
</el-form-item> -->
            <el-form-item prop="email" label="旧密码" label-position="left" label-width="80px">
              <el-input v-model="oldPassword" placeholder="请输入旧密码"></el-input>
            </el-form-item>
            <el-form-item prop="newPhone" label="新密码" label-position="left" label-width="80px">
              <el-input v-model="newPassword" placeholder="请输入新密码(6-20字母+数字组合!)">
              </el-input>
            </el-form-item>
            <el-form-item prop="renewPassword" label="密码确认" label-position="left" label-width="80px">
              <el-input v-model="renewpassword" placeholder="再次输入新密码(6-20字母+数字组合!)"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="section_3 flex-row justify-between" style="margin-top:200px;">
          <div class="text-wrapper_3 flex-col"><span class="text_9" @click="confirm">&nbsp;确认</span></div>
          <div class="text-wrapper_4 flex-col"><span class="text_10">取消</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { changePwd } from '@/api/user';
export default {
  data() {
    return {
      usrname: '888945',
      editUsrname: false,
      smsCode: '',
      oldPassword: '',
      newPassword: '',
      renewpassword: '',
      phone: '',

    };
  },
  methods: {
    async sendSmsCode() {

      let res = await this.$store.dispatch('sms/sendSmsCode', { mobile: parseInt(this.phone), scene: 'YZMDL' })
      if (res.data.code == 1) {
        this.$message({
          message: '发送成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error'
        });

      }
    },
    confirm() {
      if (this.renewpassword == this.oldpassword) {
        this.$message({
          message: '新密码不能和旧密码相同',
          type: 'error'
        });
        return;
      }
      changePwd({
        old_password: this.oldPassword,
        password: this.newPassword,
        password_confirm: this.renewpassword
      }).then(res => {
        if (res.data.code == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.$router.push('/store/dashboard/profile');
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }
      }).catch(err => {
        console.error(err);
        this.$message({
          message: '修改失败，请稍后再试',
          type: 'error'
        });
      });
    },
  },

};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.scaler_phone {
  transform-origin: top left;
  transform: scale(0.75);
}

::v-deep .el-input__inner {
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid;
  border-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%) 1;
}

::v-deep .el-input__inner::placeholder {
  color: gray;
  opacity: 1;
}

::v-deep .el-input-group__append {
  background-color: transparent;
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 110, 249, 1);
  padding: 0px;
}

.append_button {
  height: 30px;
  background-color: white;
  line-height: 30px;
  border-radius: 15px;
  font-size: x-small;
  border: 1px rgba(177, 110, 249, 1) solid;
  color: rgba(100, 100, 100, 1);
  cursor: pointer;
}
</style>